import { ACTION_BUTTON_MESSAGES, ActionButtonMessages } from "@/messages/action-buttons.messages";
import { SIDEBAR_MESSAGES, SidebarMessages } from "@/messages/layout/sidebar";
import { TABLE_COLUMNS_MESSAGES, TableColumnsMessages } from "@/messages/tables/columns.messages";

export type StatisticsPageMessages = ActionButtonMessages &
  SidebarMessages &
  TableColumnsMessages & {
    breadCrumbTitle: string;
    pageTitle: string;
    detailsSection: string;
    performanceSection: string;
    insightsSection: string;

    noDataMessage: string;

    errorLoadingStatistics: string;
    refreshButton: string;

    // Confirmation dialog messages
    resetDialogTitle: string;
    resetDialogDescription: string;
    resetDialogCancel: string;
    resetDialogConfirm: string;

    // Error Messages for Table and Data
    statisticsErrorToLoad: string;
    statisticsNotFoundError: string;
    statisticsNotFoundDescription: string;
    statisticsErrorAlt: string;
    statisticsNotFoundAlt: string;

  // Table Column Messages
  scheduleColumn: string;
  sentColumn: string;
  deliveredColumn: string;
  readColumn: string;
  clickedColumn: string;
  failedColumn: string;
  optionsColumn: string;

    //popover
    statsDetails: string;
  };

export const STATISTICS_PAGE_MESSAGES: StatisticsPageMessages = {
  // Page titles
  breadCrumbTitle: "Estatísticas",
  pageTitle: "Estatísticas da campanha",

  // Section titles
  detailsSection: "Detalhes da Campanha",
  performanceSection: "Desempenho",
  insightsSection: "Insights",

  // No data message
  noDataMessage: "Nenhum dado estatístico disponível para esta campanha.",

  // Error loading data
  errorLoadingStatistics: "Erro ao carregar as estatísticas. Tente novamente.",
  refreshButton: "Atualizar Dados",

  // Confirmation dialog messages
  resetDialogTitle: "Redefinir Estatísticas",
  resetDialogDescription:
    "Tem certeza de que deseja redefinir as estatísticas? Essa ação não pode ser desfeita.",
  resetDialogCancel: "Não",
  resetDialogConfirm: "Sim",

  // Error Messages for Table and Data
  statisticsErrorToLoad: "Erro ao carregar os dados estatísticos.",
  statisticsNotFoundError: "Dados não encontrados.",
  statisticsNotFoundDescription: "Não há registros para exibir no momento.",
  statisticsErrorAlt: "Ícone representando erro.",
  statisticsNotFoundAlt: "Ícone representando dados não encontrados.",

  // Table Column Messages
  scheduleColumn: "Disparo",
  sentColumn: "Enviados",
  deliveredColumn: "Entregues",
  readColumn: "Lidos",
  clickedColumn: "Cliques",
  failedColumn: "Erros",

  //popover
  statsDetails: "Detalhes",

  ...ACTION_BUTTON_MESSAGES,
  ...SIDEBAR_MESSAGES,
  ...TABLE_COLUMNS_MESSAGES,
};
